const instructor = [
  {
    action: 'access',
    subject: 'account'
  },

  {
    action: 'access',
    subject: 'accessDenied'
  },

  {
    action: 'access',
    subject: 'asset'
  },

  {
    action: 'access',
    subject: 'assetChild1'
  },

  {
    action: 'access',
    subject: 'assetChild2'
  },

  {
    action: 'access',
    subject: 'projects'
  },

  {
    action: 'access',
    subject: 'home'
  },

  {
    action: 'access',
    subject: 'map'
  },

  {
    action: 'access',
    subject: 'mapChild1'
  },

  {
    action: 'access',
    subject: 'mapChild2'
  },

  {
    action: 'access',
    subject: 'maps'
  },

  {
    action: 'access',
    subject: 'notFound'
  }
]

export default instructor
